/*
 * @description: 路由配置
 */
import {createRouter, createWebHistory} from "vue-router";
import {store} from "@/store/index.js";
import {constantRoutes, asyncRoutes} from "./data";
import {redirectPath} from '@/routes/redirect.js'
import {getToken, saveToken} from "utils/auth";
import cloneDeep from "lodash/cloneDeep";
import {getUserInfo} from "@/model/user";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css' //这个样式必须引入

import {$localStorage} from '@/utils/storage'

NProgress.configure({
    showSpinner: true,  // 显示加载图标
    ease: 'linear',        // 改变动画的速度曲线
    speed: 200,             // 改变动画的速度
    trickle: false,           // 开启渐隐效果
    template: `<div class="bar" role="bar">
                <div class="peg"></div>
            </div>
            <div class="loading-wrap">
              <div class="spinner" role="spinner">
                  <div class="spinner-icon"></div>
                  <span class="loading-text">数据正在加载，请稍后……</span>
              </div>
            </div>
`
});
// , ...asyncRoutes
export const router = createRouter({
    history: createWebHistory(),
    routes: constantRoutes,
});

//  获取用户信息并保存
const saveUserInfo = async () => {
    if (!store.getters.userInfo || !Object.keys(store.getters.userInfo).length) {
        try {
            let res = await getUserInfo({source: '1'});
            if (res?.code === 200) {
                const userInfo = {
                    user: res?.user,
                    permissions: res?.permissions || [],
                    featurePermissionsList: res?.featurePermissionsList || []
                }
                store.dispatch('user/saveLogin', userInfo || {})
            }

        } catch (e) {
            console.log(e)
        }
    }

};

// 过滤掉用户没有权限的路由
const filterPermissions = (route) => {
    const perms = store.getters.permissions || [];

    if (route && route.length) {
        let temp = [];
        if (route && route.length) {
            route.forEach((e) => {
                if (e?.meta?.perms) {
                    if (perms.includes(e.meta?.perms) || e.meta.perms === "*" || !e.meta.perms) {
                        temp.push(e);
                    }
                    if (e.children && e.children.length) {
                        e.children = filterPermissions(e.children);
                    }
                }
            });
        }
        return temp;
    }
};

// 过滤出参与渲染的路由 即：isLayout不为true且hidden不为true的路由数据
function filterLayout(route) {
    const routesArr = [];
    const perms = store.getters.permissions || [];

    const isAdmin =
        perms?.includes('*:*:*') ||
        perms?.includes('adminFlag') ||
        store.getters?.userInfo?.admin;

    if (!route || !route.length) {
        return routesArr;
    }

    route.forEach((e) => {
        if (e.hidden) {
            return;
        }
        // 判断是否为布局路由且是否存在子路由
        if (e.isLayout && e?.children?.length) {
            // 处理布局路由下的子路由
            e.children.forEach((elem) => {
                // 如果子路由被设置为隐藏，或者当前用户不是管理员且没有权限访问此路由，则跳过此次循环
                if (elem?.hidden || (!isAdmin && !perms.includes(elem?.meta?.perms) && elem.meta.perms !== '*' && elem.meta.perms)) {
                    return;
                }
                // 将满足条件的子路由添加到结果数组中
                routesArr.push(elem);
                // 如果子路由还存在子路由，则递归处理
                if (elem?.children?.length) {
                    elem.children = filterLayout(elem.children);
                }
            });
        } else {
            // 将非布局路由添加到结果数组中
            routesArr.push(e);
            // 如果当前路由存在子路由，则递归处理
            if (e?.children?.length) {
                e.children = filterLayout(e.children);
            }
        }
    });

    return routesArr;
}

//  过滤出子模块路由
const filterModuleRoute = (route) => {
    if (route && route.length) {
        route.forEach((e) => {
            // 将子模块路由缓存，用于侧边导航渲染
            if (e?.independent === "module") {
                if (e?.children?.length) {
                    // 保存子模块路由
                    store.dispatch("permission/generateModuleRoutes", e);
                }
            } else {
                if (e?.isLayout) {
                    filterModuleRoute(e?.children)
                }
            }
        });
    }
};


function handle_mobile_page(to, from, next) {
    const mathRoutes = ['/login', '/404', '/landing', '/home','/screenBoard']
    let regex = /^\/[lLaA]\d+$/;
    // 未登录的路由处理
    if (regex.test(to.path)) {
        const type = /[Aa]/.test(to.path)
        if(type){
            window.location.href = `/landing?alarmId=${to.path.match(/\d+/g)}&type=algoRun`;
        } else {
            window.location.href = `/landing?alarmId=${to.path.match(/\d+/g)}`;
        }

    } else if (mathRoutes.includes(to.path)) {
        next()
    } else {
        next({path: '/login'})
    }
}


router.beforeEach(async (to, from, next) => {

    // 处理单点登录携带的 token 参数，免密登录后重定向到原路径
    // 1. 定义想要删除的 query 参数名
    const keyToRemove = 'ssoToken'
     // 2. 检查该参数是否存在 (防止无限循环的关键)
    if (to.query[keyToRemove]) {
        saveToken(to.query[keyToRemove]) // 保存token
        // 3. 创建一个新的 query 对象 (不要直接修改原对象)
        const newQuery = { ...to.query }
        delete newQuery[keyToRemove]
        // 4. 调用 next 传入新位置，触发新的导航
        next({
        path: to.path,          // 保持路径不变
        query: newQuery,        // 使用清洗后的 query
        params: to.params,      // 重要：保留动态路由参数 (如 /user/:id)
        replace: true         // 可选：是否替换当前历史记录，避免回退到带参数的 URL
        })
    }

    if(to.path.includes("video-stream-iframe")){
      next()
    }

    // 启动进度条
    NProgress.start();

    const redirectRootPath = Object.keys(redirectPath)
    // 登录信息持久化
    const token = getToken()
    // // 设置子路由需要激活的父级路由
    // await store.dispatch("permission/updateRootPath", to.meta?.rootPath || null);
    // // 判设置前往的路由类型
    // await store.dispatch("permission/updateRouteType", to.meta?.type || null);
    let regex = /^\/[lLaA]\d+$/;
    // 用户拥有权限的 路由渲染数据
    const routeConfig = store.getters?.renderRoutes || [];// asyncRoutes
    // 参与布局渲染的路由
    const filterRouteList = store.getters?.filterRouteList || [];

    if (token) {
        if (regex.test(to.path)) {
            const type = /[Aa]/.test(to.path)
           // 大写L 调应用系统接口；小写l掉中台接口
            if(type){
                window.location.href = `/landing?alarmId=${to.path.match(/\d+/g)}&type=algoRun`;
            } else {
                window.location.href = `/landing?alarmId=${to.path.match(/\d+/g)}`;
            }
        }

        // 判断vuex是否存在用户信息
        if (!store.getters.userInfo || !Object.keys(store.getters.userInfo).length) {
            await saveUserInfo()
        }


        if (routeConfig?.length) {// asyncRoutes /home
            // 子模块路由拆分
            await filterModuleRoute(routeConfig);

            if (!filterRouteList?.length) {
                // 过滤所有参与渲染的路由信息
                let routeList = filterLayout(cloneDeep(routeConfig));
                await store.dispatch("permission/updateFilterRoutes", routeList);
            }


            //已登录如果往登陆跳转，进行下路由重定向
            if (to.path === '/login') {
                next('/home')
            } else {
                handle_mobile_page(to, from, next)
            }
        } else {
            // vuex中路由信息未存储时
            try {
                // if (!store.getters?.userInfo || !Object.keys(store.getters.userInfo).length) {
                //     await saveUserInfo()
                // }

                await store.dispatch("permission/generateRoutes");//生成 asyncRoutes 
                const routeConfig = store.getters.renderRoutes;// asyncRoutes
                // 同步缓存参与布局渲染的路由
                let routeList = filterLayout(cloneDeep(routeConfig));
                await store.dispatch("permission/updateFilterRoutes", routeList);//filterRouteList
                await routeConfig.forEach((e) => {
                    router.addRoute(e);
                });

                // 替换导航是，做拦截
                next({...to, replace: true}); // 中断当前导航，执行新的导航

            } catch (e) {
                next();
            }
        }

    } else {
        await store.dispatch("permission/updateFilterRoutes", [])
        if (to.path === '/home') {
            next('/login')
        } else {
            handle_mobile_page(to, from, next)
        }

    }
});

function getSubstringBeforeFourthSlash(url) {
    // 使用split方法根据斜杠分割URL
    var parts = url.split('/');

    // 确保URL中有至少四个斜杠
    if (parts.length >= 4) {
        // 截取第四个斜杠之前的所有部分，并使用join方法将它们重新组合成一个字符串
        return parts.slice(0, 4).join('/');
    } else {
        // 如果URL中没有四个斜杠，则返回整个URL
        return url;
    }
}


router.afterEach(() => {
    NProgress.done(); // 在导航完成后结束进度条
});

router.onError((handler) => {
    console.log("error:", handler);
});

export function resetRouter() {
    const newRouter = createRouter();
    router.resolve = newRouter.resolve; // reset router
}

export default function (app) {
    app.use(router);
    return router;
}
